import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    data: _ctx.tableData,
    border: "",
    style: {"width":"100%"},
    "max-height": "400px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "发票号码",
        prop: "no",
        "min-width": "120"
      }),
      _createVNode(_component_el_table_column, {
        label: "发票代码",
        prop: "code",
        "min-width": "120"
      }),
      _createVNode(_component_el_table_column, {
        label: "发票校验码",
        prop: "checkCode",
        "min-width": "180"
      }),
      _createVNode(_component_el_table_column, {
        label: "开票日期",
        prop: "date"
      }),
      _createVNode(_component_el_table_column, {
        label: "发票金额",
        prop: "amount",
        align: "right",
        "min-width": "120"
      }, {
        default: _withCtx(({ row }) => [
          _createElementVNode("span", {
            style: _normalizeStyle({ color: row.amount < 0 || row.type === '退票' ? '#E6A23C' : '#67C23A', fontWeight: 'bold' })
          }, _toDisplayString(_ctx.$currency(row.amount)), 5)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "发票类型",
        prop: "type",
        width: "110",
        align: "center"
      }, {
        default: _withCtx(({ row }) => [
          _createVNode(_component_el_tag, {
            type: row.type === '退票' || row.amount < 0 ? 'warning' : 'success',
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(row.type === '退票' || row.amount < 0 ? '退票' : '正常发票'), 1)
            ]),
            _: 2
          }, 1032, ["type"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "登记日期",
        prop: "createTime",
        "min-width": "120"
      }),
      _createVNode(_component_el_table_column, {
        label: "状态",
        prop: "status",
        width: "110",
        align: "center"
      }, {
        default: _withCtx(({ row }) => [
          _createVNode(_component_el_tag, {
            type: row.status === 0 ? 'info' : 'success',
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(row.status === 0 ? '已退票作废' : '正常'), 1)
            ]),
            _: 2
          }, 1032, ["type"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}